// extracted by mini-css-extract-plugin
export default {"container":"row_19-Zk","title":"row_tit_1wtBS","button":"row_but_NGhb0"};